var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-pull-to-refresh",class:{
    'is-shown': _vm.distance > 0 || _vm.refreshing,
    'is-armed': _vm.armed,
    'is-refreshing': _vm.refreshing,
    'is-dragging': _vm.dragging,
  },style:(_vm.position),attrs:{"aria-hidden":"true"}},[_c('BaseIcon',{staticClass:"base-pull-to-refresh__icon",style:({ transform: `rotate(${_vm.distance * 3}deg)` }),attrs:{"name":"rotate-cw"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }